import { Descriptions, Divider } from "antd";
import React from "react";
import { ViewItem } from "../../../../constants/pricing";
import { Crane1ItemCodes, SrDifficulties } from "../../../../constants/serve";

type ServeItemPropsVt = {
  items: ViewItem[] | null | undefined;
  onOpenNavigate: (item: ViewItem) => void;
}

type ServeItemPropsCranel = {
  item: ViewItem | null | undefined;
  onOpenNavigate: (item: ViewItem) => void;
}

// 车辆运输
const VT: React.FC<ServeItemPropsVt> = ({ items, onOpenNavigate }) => {
  if (!items) return <></>;

  const viewer = items.map((el: ViewItem) => {
    return (
      <>
        <Descriptions
        title={`车辆运输`}
        column={4}
        key={`vt-care-${el.item!.id}`}
      >
        <Descriptions.Item label="运输时间">
          {el.item?.dayTime ? "白天" : "晚上"}
        </Descriptions.Item>
        <Descriptions.Item label="距离" >
          <a
            onClick={() => {
              el.navigation && onOpenNavigate(el)
            }}
            style={{ textDecoration: "underline" }}
          >{Math.ceil((el.navigation?.distance || 0) / 1000)} 公里</a>
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{(el.item?.totalFee || 0) / 100}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
      </>
    )
  })
  return (
    <>
      {viewer}
    </>
  );

};

// 吊车
const Crane1: React.FC<ServeItemPropsCranel> = ({ item, onOpenNavigate }) => {

  if (item == null) return <></>;

  return (
    <>
      <Descriptions title="吊车 - 事故救援" column={4}>
        <Descriptions.Item label="吨位">
          {Crane1ItemCodes[item.item!.tonnage]} 
        </Descriptions.Item>
        <Descriptions.Item label="距离">
          <a 
            style={{ textDecoration: "underline" }}
            onClick={() => {
              item.navigation && onOpenNavigate(item)
            }}
          >{Math.ceil((item.navigation?.distance || 0) / 1000)} 公里</a>
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{item.item.totalFee / 100}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

// 随车吊
const Crane: React.FC<ServeItemPropsCranel> = ({ item, onOpenNavigate }) => {
  if (item == null) return <></>;

  return (
    <>
      <Descriptions
        title="随车吊 - 事故救援"
        column={4}
      >
        <Descriptions.Item label="运输时间">
          {item.item?.dayTime ? "白天" : "晚上"}
        </Descriptions.Item>
        <Descriptions.Item label="距离" >
          <a 
            style={{ textDecoration: "underline" }}
            onClick={() => {
              item.navigation && onOpenNavigate(item)
            }}
          >{Math.ceil((item.navigation?.distance || 0) / 1000)} 公里</a>
        </Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{item.item!.totalFee / 100}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

// 辅助轮
const Wheel: React.FC<{ item: ViewItem | null | undefined }> = ({ item }) => {
  if (item == null) return <></>;
  return (
    <>
      <Descriptions
        title="辅助轮 - 事故救援"
        column={4}
      >
        <Descriptions.Item label="个数" span={1}>{item.item!.count}</Descriptions.Item>
        <Descriptions.Item label="总费用">
          ¥{(item.item!.totalFee || 0) / 100}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

// 现场救援
const SR: React.FC<{ item: any | null | undefined }> = ({ item }) => {
  if (!item) return <></>;
  return (
    <>
      <Descriptions
        style={{ textAlign: "left" }}
        title="现场救援 - 事故救援"
        column={4}
      >
        <Descriptions.Item label="救援难度">
          {SrDifficulties[item.item?.difficulty]}
        </Descriptions.Item>
        <Descriptions.Item label="难度费用">
          ¥{(item.item?.baseFee || 0) / 100} 元
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

// 基础救援： 地库救援、困境救援 / 送油 / 搭电 / 换轮
const BaseRescue: React.FC<
  { item: ViewItem | null | undefined } & { title: string }
> = ({ item, title }) => {
  if (item == null) {
    return <></>;
  }

  return (
    <>
      <Descriptions
        title={`${title} - 事故救援`}
        column={4}
      >
        <Descriptions.Item label="总费用">
          ¥{(item.item!.totalFee || 0) / 100}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
    </>
  );
};

export { VT, Crane1, Crane, Wheel, SR, BaseRescue };
